import { _UnwrapAll, storeToRefs } from "pinia";
import { DisplayType, FieldType, FormDesignDto, FormDesignItemDto, FormSectionDesignDto, defaultItem, ItemsType, ITEMSWITHTAGS, CellGridExcelDto } from "./surveyDesignDtos";
import { ApiInterface, Sh, SharedService, TagCalculateItem, TagObject } from "@/core/sharedService";
import { apiRoutes } from "@/core/apiRouters";
import { computed, Ref, ref } from "vue";
import mitt from 'mitt';
import { GlobalState } from "../global/gobalState";
import { entityTypes, form_type } from "@/shared/globaEnums";
import { LocalStorageService } from "@/core/localStorage.service";
import { SurveyResponseCompleteDto, SurveyResponseDto, SurveyResponseValueDateRange, SurveyResponseValueFile } from './surveyResponseDtos';
import { SurveyBaseStore, TagValueWeighObject } from "./surveyBaseStore";
import { ResultTest, SurveyApiDto, SurveyApiListItemDto, SurveyApiParms } from "./surveyApiDtos";
import { v4 as uuidv4 } from 'uuid';
import { JSONPath } from 'jsonpath-plus';
import { Form_status } from "../forms/dtos";
import * as signalR from "@microsoft/signalr";
type Events = {
  deploy: boolean;
};
interface ItemConTag {
  tag: string;
  [key: string]: any; // Permite otras propiedades
}

class SurveyStore extends SurveyBaseStore { // SurveyBaseStore es la base donde apunta al store.
  originSelectorShow: Ref<boolean> = ref(false);
  originSelectorItem: Ref<FormDesignItemDto> = ref(null);
  event = mitt<Events>();
  formulaCreatorShow: Ref<boolean> = ref(false);
  formulaCreatorItem: Ref<FormDesignItemDto> = ref(null);
  isLoading = ref<boolean>(false);

  constructor() {
    super();
  }
  release = () =>{
    this.state.release();
  }
  moveTo = (item: FormDesignItemDto, order: number) =>  {
    const itemsGroup = this.itemsOrganized.value.find(i => i.items.find(it => it.id == item.id));
    // console.log('Items Group:', itemsGroup);
    
    if (!itemsGroup) {
        console.log('No se encontró el grupo de ítems.');
        return;
    }
    
    const itemTarget = itemsGroup.items.find(i => i.order == order);
    
    if (!itemTarget) {
        console.log('No se encontró un ítem con el orden especificado:', order);
        return;
    }

    itemTarget.order = item.order;
    item.order = order;

    // console.log('Orden actualizado:', { itemTarget, item });
}

  deployAllSections = (deploy: boolean) => {
    this.event.emit("deploy", deploy);
  }
  deleteItem = (item: FormDesignItemDto): boolean => {
    this.removeItem(item);
    return true;
  }

  getGroupOfItem = (item: FormDesignItemDto | string): FormSectionDesignDto => {
    return this.itemsOrganized.value.find(i => i.items.find(it => it.id == (typeof item == 'string' ? item : item.id)));
  }

  lasItemGroup = (itemGroup: FormDesignItemDto | FormSectionDesignDto): number => {
    // console.log('Item Group:', itemGroup);
    
    let i: FormSectionDesignDto = itemGroup instanceof FormDesignItemDto ? this.getGroupOfItem(itemGroup) : itemGroup;
    // console.log('Grupo de ítems:', i);
    
    if (!i || !i.items) {
        // console.log('El grupo de ítems o sus ítems no están definidos.');
        return 0;
    }
    
    if (i.items.length) {
        return i.items[i.items.length - 1].order;
    }
    
    return 0;
  }

  addDesign = () => {
    this.newDesign();
    this.newItem(FieldType.SECTION);
  }
  newItem = (type: FieldType, inheritsId?: string): FormDesignItemDto => {
    let item: FormDesignItemDto;
    try {
      if ([FieldType.SECTION.toString(), FieldType.NEWPAGE.toString()].includes(type)) {
        const order: number = this.itemsOrganized.value.length ?
          this.itemsOrganized.value[this.itemsOrganized.value.length - 1].order + 1 : 1;
        item = defaultItem(type, this.currentDesign.value, order);
    
      } else if (this.currentSection.value != null) {
        item = defaultItem(type, this.currentDesign.value, this.currentSection.value, this.getNewTag());
        if(inheritsId && type == FieldType.APIREST){
          this.getApi(inheritsId).then(api => {
            if(api!=false){
              item.content = JSON.stringify(this.getVarsApi(api as SurveyApiDto));
              this.selectItem(item.id);
            }
          })
        }
      } else {
        throw "No hay ninguna sección seleccionada.";
      }
    } catch (e) {
      throw e;
    }
    const last = this.currentDesign.value.items.filter(i => i.type == type);
    if(last.length){
      item.properties = JSON.parse(JSON.stringify(last[last.length - 1].properties));
    }
    this.addItem(item);
    
    return item;
  }
  getNewTag = (otherTags?: string[] ) => {
    let lastCounter = this.currentDesign.value.cab.fieldCounter ?? 0;
    lastCounter++;
    this.bindCab("fieldCounter", lastCounter);
    const newTag = "v-"+lastCounter.toString();
    if(!this.validTag(newTag)) return this.getNewTag();
    if(otherTags){
      if(otherTags.includes("v-"+lastCounter.toString())){
        return this.getNewTag(otherTags);
      }
    }    
    if(this.findTag("v-"+lastCounter.toString())){
      return this.getNewTag();
    }
    return "v-"+lastCounter.toString();
  };
  getTags = () => {
    const tags = {};
    for(const i of this.currentDesign.value.items){
      tags[i.id] = i.tag;
      if(i.items && i.items.length){
        for(const [index, j] of i.items.entries()){
          tags[i.id + "." +  index.toString()] = j.tag;
        }
      }
      if(i.gridDesign && i.gridDesign.headers.length && i.gridDesign.rows.length){
        for(const [index, j] of i.gridDesign.rows.entries()){
          for(const [index2, k] of j.cells.entries()){
            tags[i.id + "." +  index.toString() + "." + index2.toString()] = k.tag;
          }
        }
      }
    }
    return tags;
  }
  
  validTag = (tag: string, target?: string) => {
    let id = "";
    let idx1 =-1;
    let idx2 =-1;
    let isValid = true;
    if(target){
      const targets = target.split(".");
      id = targets[0];
      idx1 = targets.length > 1 ? parseInt(targets[1]) : -1;
      idx2 = targets.length > 2 ? parseInt(targets[2]) : -1;
    }
    const tags = this.getTags();
    for(const [key, value] of Object.entries(tags)){
      if(value == tag){
        if(!target || (key !== target)){
          isValid = false;
          break;
        }
      }
    }
    return isValid;
  }

  findTag = (tag: string) => {
    let id: string = null;
    for(const i of this.currentDesign.value.items.filter(i => i.type !== FieldType.CHART)){
      if(i.tag == tag) {
        id = i.id;
        break;
      }
      if(i.items && i.items.length){
        
         for(const ii of i.items){
          if (ii.tag == tag ){
            id = ii.label;
            break;
          }
        } 
      }
      if(i.gridDesign && i.gridDesign.headers.length && i.gridDesign.rows.length){
        for(const [index, j] of i.gridDesign.rows.entries()){
          for(const [index2, k] of j.cells.entries()){
            if(k.tag == tag && !k.isReference){
              id = index2.toString()  + "-" +  j.title;
              break;
            }
          }
          if(id) break;
        }
      }
      if(id) break;
    }
    return id;
  }
  loadDesign = async (formId: string) => {
    try {
      this.loading.value = true;
      this.errors.value = [];
      const form: FormDesignDto = await Sh.api<FormDesignDto>({
        method: 'GET',
        route: apiRoutes.surveyGetDesign,
        params: [formId],
      });
      this.setDesign(form);
      
    } catch (e) {
      this.errors.value = ["Error"];
    } finally {
      this.loading.value = false;
    }
  }
  copyDesign = (from: DisplayType, to: DisplayType) => {
    const fromDesign = from == DisplayType.EDIT ? this.currentItem.value.properties.input : (from == DisplayType.DISPLAY ? this.currentItem.value.properties.screen : this.currentItem.value.properties.print);
    switch(to){
      case DisplayType.EDIT:
        this.currentItem.value.properties.input = {...fromDesign};
        break;
      case DisplayType.DISPLAY:
        this.currentItem.value.properties.screen = {...fromDesign};
        break;
      case DisplayType.PDF:
        this.currentItem.value.properties.print = {...fromDesign};
        break;        
    }
    this.updateItem(this.currentItem.value);
  }
  saveCab = async () => {
    try {
      if(!this.currentDesign.value.cab.clientId) {
        const {
          currentContext
        } = storeToRefs(GlobalState());
        const currentEntity = currentContext.value.entity;
        if(currentEntity.clientId) {
          this.currentDesign.value.cab.clientId = currentEntity.clientId;
        }else if(currentEntity.entityType == entityTypes.CLIENT ){
          this.currentDesign.value.cab.clientId  =  currentEntity.id;
        }else{
          alert("cliente no asignado");
          return;
        }

      }
      const errors = this.validCab();
      if(errors.length){

        let messagesErrors = errors.map(error => error).join('<br/>');

        Sh.showGenericDialog({
          title: "Error al crear el formulario",
          message: messagesErrors,
          confirmOnly: true,
          confirmText: "Cerrar"
        })
        // alert("Error al crear el formulario \n" + errors.join("\n"));
        return;
      }
      this.loading.value = true;
      this.errors.value = [];
      const form: FormDesignDto = await Sh.api<FormDesignDto>({
        method: 'POST',
        route: apiRoutes.surveyDesignUpdate,
        data: this.currentDesign.value,
      });
      this.setDesign(form);
      LocalStorageService.setValue("lastDesign", {id: form.cab.id, isNew : false});
      Sh.showToast("Formulario guardado correctamente", 8, false);
    } catch (e) {
      Sh.showToast("Error al guardar el formuario", 8, true);
      this.errors.value = ["Error"];
    } finally {
      this.loading.value = false;
    }
  }
  validCab = ():string[] =>{
    const cab = this.currentDesign.value.cab;
    const errors: string[] = [];
    if(!cab.name) errors.push("El nombre del formulario es obligatorio." + "\n");
    if(!cab.initDate || !cab.initDate.trim().length) errors.push("La fecha de inicio formulario es obligatoria." + "\n");
    if(!cab.endDate || !cab.endDate.trim().length) errors.push("La fecha de fin formulario es obligatoria." + "\n");
    this.validItems(errors);
    this.validateReferences();
    return errors; 
  }
  validateReferences = () => {

     try {
        const formulas = this.currentDesign.value.items.filter(i=> i.type == FieldType.FORMULE);
        const tagsValues = this.getTagsWithValues();
        const errors:string[] =  [];

        if(!formulas || formulas.length == 0 ) {
          return;
        }
        const frm = this.formulaAssignable.value;
        let formulasToAply: {id: string, tag: string, content: string,  tags: TagObject[]}[] = [];
        for(const i of formulas){
          if(Sh.isNullOrEmptyOrZero(i.content)) continue;
          const tag: {id: string, tag: string, content: string, tags: TagObject[]} = {id: i.id, tag: i.tag, content: i.content, tags: Sh.extractTags(i.content)};
          formulasToAply.push(tag);
        }
        if(!formulasToAply.length){
          return;
        }
        const topo: TagCalculateItem[] = Sh.topologicalSortFormulas(formulasToAply.map(i=> <TagCalculateItem>{tag: i.tag, tags: i.tags}));
        formulasToAply = this.ordenArray(formulasToAply, topo);
        for(const f of  formulasToAply){
          let formula: string = f.content;
              for(const t of f.tags){
                if(!tagsValues[t.tag]){
                  errors.push(`la formula ${f.tag} hace referencia al tag ${t.tag} y este no existe `)
                }
              }
        }
        const grids = this.currentDesign.value.items.filter(i => i.type === FieldType.EXCELGRID);
        for(const gr of grids){
           for(const row of gr.gridDesign.rows){
            for(const r of row.cells.filter(rr => rr.isReference)){
              const tag = r.tag.replace(".value", "").replace(".VALUE", "");
              if(tagsValues[tag] === undefined){
                  errors.push(`la grilla  ${gr.label} en la fila ${row.title} hace referencia al tag ${tag} y este no existe `)
              }

            }
          } 
        }
        const grafs = this.currentDesign.value.items.filter(i => i.type === FieldType.CHART);
        for(const gr of grafs){
           for(const row of gr.items){
              const tag = row.tag.replace(".value", "").replace(".VALUE", "");
              if(tagsValues[tag] === undefined){
                  errors.push(`el gráfico  ${gr.label} en la serie ${row.label} hace referencia al tag ${tag} y este no existe `)
              }
          } 
        }
        if(errors.length){
          Sh.showGenericDialog({
          title: "Aviso no bloqueante",
          message: errors.join("<br/>"),
          confirmOnly: true,
          confirmText: "Cerrar"
        })
        }
      }catch(e){
        console.log(e);
        alert("Error en formulacion");
      }

  }
  validItems = (errors: string[]) =>{
    const grids = this.currentDesign.value.items.filter(i => i.type == FieldType.EXCELGRID);
    for(const i of grids){ 
      for(const r of i.gridDesign.rows){
        for(const c of r.cells){
          if(c.tag.trim().length == 0){
            errors.push("El tag de la celda " + r.title + " es obligatorio." + "\n");
          }
        }
      }
    }

    return errors; 
  }

  bindCab = (field: string, value: any) => {
    
    this.currentDesign.value =  {...this.currentDesign.value, cab: {...this.currentDesign.value.cab, [field]: value}}
    if(field == "formType" && value == form_type.COMPONENT){
      this.currentDesign.value.cab.endDate = '01-01-1900';
      this.currentDesign.value.cab.initDate = '01-01-1900';
    }
    this.setDesign(this.currentDesign.value);
  }
  targetToProperty = (target: DisplayType):string => {
    return {[DisplayType.EDIT]: 'input', [DisplayType.DISPLAY]: 'screen', [DisplayType.PDF]: 'print'}[target];
  }
  bindItem =(type: 'item'|'style'|'display', target: DisplayType, labelContent: 'contentStyle'|'labelStyle' , field: string, value: any) => {
    switch(type){
      case 'style':
        this.currentItem.value.properties[this.targetToProperty(target)][labelContent][field] = value;
        break;
      case 'item':
        if(field == 'tag' && value !== this.currentItem.value[field]){
          const id = this.findTag(value);
          
          if(id && id !== this.currentItem.value.id) return false;
        }
        this.currentItem.value[field] = value;
        break;
      case 'display':
        this.currentItem.value.properties[this.targetToProperty(target)][field] = value;
        break;
    }
  } 
  getValueItem = (type: 'item'|'style'|'display', target: DisplayType, labelContent: 'contentStyle'|'labelStyle' , field: string) => {
    switch(type){
      case 'style':
        return this.currentItem.value.properties[this.targetToProperty(target)][labelContent][field];
        break;
      case 'item':
        return this.currentItem.value[field] ;
        break;
      case 'display':
        return this.currentItem.value.properties[this.targetToProperty(target)][field];
        break;
    }
  }
 

  defaltItemValue = (item: FormDesignItemDto) => {
    switch(item.type){
      case FieldType.DATERANGE: return new SurveyResponseValueDateRange();
      case FieldType.DROPDOWN: return [];
      case FieldType.MULTYDROPDOWN: return [];
      case FieldType.FILE: return new SurveyResponseValueFile();
      case FieldType.FORMREF:
        if(item.itemsType == ItemsType.DATE) return "";
        if(item.itemsType == ItemsType.NUMBER) return 0;
        if(item.itemsType == ItemsType.TEXT) return "";
        break;
      case FieldType.FORMULE: return 0;
      case FieldType.GRID: return [];
      case FieldType.NUMBER: return 0;
      case FieldType.YESNO: return Boolean;
      default: return "";
    }
  }

  //NUEVO MÉTODO PARA MOSTRAR EL DIÁLOGO DE FÓRMULAS
   showFormulaCreator = (item: FormDesignItemDto) => {
    this.formulaCreatorItem.value = item;
    this.formulaCreatorShow.value = true;
  }

  showOriginSelector = (item: FormDesignItemDto) => {
    this.originSelectorItem.value = item;
    this.originSelectorShow.value = true;
  }
  getForms = async (components: boolean = false) => {
    try{
      this.isLoading.value = true;
      const list = await Sh.api<{id: string, name: string}[]>({
        method: 'GET',
        route: !components ?  apiRoutes.surveyDesingListSimple : apiRoutes.surveyDesingListSimpleCompontents
      });
      this.isLoading.value = false;
      return list;
    }catch(e){
      this.isLoading.value = false;
      console.log("Error recuperando formularios");
      return [];
    }
    
  }
  getItems = async (formId: string) => {
    try{
      const list = await Sh.api<{id: string, name: string, surname: string}[]>({
        method: 'GET',
        route: apiRoutes.surveyDesingListItemSimple,
        params: [formId]
      });
      return list;
    }catch(e){
      console.log("Error recuperando formularios");
      return [];
    }
  }

  setComponent = async (formId: string ) => {
    try {
      this.loading.value = true;
      this.errors.value = [];
      const form: FormDesignDto = await Sh.api<FormDesignDto>({
        method: 'GET',
        route: apiRoutes.surveyGetDesign,
        params: [formId],
      });
      const oldDatas: {oldId: string, oldTag: string, newId: string, newTag: string}[] = [];
      const items: FormDesignItemDto[] = form.items.sort((a, b) => a.order - b.order);
      const formulas: FormDesignItemDto[] = items.filter(i => i.type == FieldType.FORMULE);
      const sections: FormDesignItemDto[] = items.filter(i => [FieldType.SECTION, FieldType.NEWPAGE].includes(i.type));
      const newTagsGenerateds: string[] = [];
      const itemsGrids = items.filter(i => i.type == FieldType.EXCELGRID);
      const itemsChars = items.filter(i => i.type == FieldType.CHART);
      const itemsNormal = items.filter(i => ![FieldType.EXCELGRID, FieldType.CHART, FieldType.SECTION, FieldType.FORMULE].includes(i.type));

      type tags =  {
        id: string;
        tipo: FieldType;
        oldTag: string;
        newTag: string;
        position: number;
        isRef: boolean;
        column?: number;
        oldId?: string;
      }
      const tagsNews: tags[] = [];
      let oldOrder = this.itemsOrganized.value.length ? this.itemsOrganized.value[this.itemsOrganized.value.length - 1].order : 0;
      // Actualizamos las secciones
      for(const i of sections){
        
        let newTag = i.tag;
        if(this.findTag(i.tag) || tagsNews.find(t => t.newTag == i.tag)!= null){
          newTag = this.getNewTag(tagsNews.map(t => t.newTag))
        }
        
        tagsNews.push({
          oldId: i.id,
          id: i.id = uuidv4(),
          tipo: i.type, 
          oldTag: i.tag,
          newTag: newTag,
          isRef: false,
          position: -1,
        });
        i.isNew = true;
        i.tag = newTag;
        oldOrder++;

         i.order =  oldOrder;
      }

      // Actualizamos los items normales 
      for(const i of itemsNormal){
        
        let newTag = i.tag;
        if(this.findTag(i.tag) || tagsNews.find(t => t.newTag == i.tag && t.id!= i.id)!= null){
          newTag = this.getNewTag(tagsNews.map(t => t.newTag))
        }
        i.id = uuidv4();
        i.isNew = true;
        tagsNews.push({
          id: i.id,
          tipo: i.type, 
          oldTag: i.tag,
          newTag: newTag,
          isRef: false,
          position: -1,
        });
        i.tag = newTag;
        const container = tagsNews.find(t => t.tipo == FieldType.SECTION && t.oldId == i.parentItemId);
        if(container){
          i.parentItemId = container.id;
        }
        if(i.items && i.items.length){
          for (const [index, it] of i.items.entries()) {
            if(it.tag.trim().length== 0) continue;
            newTag = it.tag;
            if(this.findTag(it.tag) || tagsNews.find(t => t.newTag == it.tag)!= null){
              newTag = this.getNewTag(tagsNews.map(t => t.newTag));
            }
           tagsNews.push({
            id: i.id,
            tipo: i.type, 
            oldTag: it.tag,
            isRef: false,
            newTag: newTag,
            position: index,
          }); 
            it.tag = newTag;
          }
        }
      }

      // actualizamos las grillas
      for(const i of itemsGrids){
        let newTag = i.tag;
        if(this.findTag(i.tag) || tagsNews.find(t => t.newTag == i.tag && i.id !=t.id)!= null){
          newTag = this.getNewTag(tagsNews.map(t => t.newTag))
        }
        i.id = uuidv4();
        
        tagsNews.push({
          id: i.id,
          tipo: i.type, 
          oldTag: i.tag,
          newTag: newTag,
          isRef: false,
          position: -1,
        });
        i.isNew = true;

        i.tag = newTag;
        const container = tagsNews.find(t => t.tipo == FieldType.SECTION && t.oldId == i.parentItemId);
        if(container){
          i.parentItemId = container.id;
        }
         for (const [index, it] of i.gridDesign.rows.entries()) {
          for (const [index2, it2] of it.cells.entries()) {
            newTag = it2.tag;
            const tnew: tags = {
              id: i.id, 
              tipo: i.type, 
              oldTag: it2.tag,
              isRef: it2.isReference,
              newTag: newTag,
              position: index,
              column: index2
            }
            if(!it2.isReference && (this.findTag(it2.tag) || tagsNews.find(t => t.newTag == it2.tag)!= null)){
              tnew.newTag = this.getNewTag(tagsNews.map(t => t.newTag));
            }
            it2.tag = tnew.newTag;
            tagsNews.push(tnew);
          }
         }
      }

        //actualizamos las fórmulas
        for(const i of formulas){
          i.isNew = true;
          let newTag = i.tag;
          if(this.findTag(i.tag) || tagsNews.find(t => t.newTag == i.tag && t.id!= i.id && !t.isRef)!= null){
            newTag = this.getNewTag(tagsNews.map(t => t.newTag));
          }
          i.id = uuidv4();
          
          tagsNews.push({
            id: i.id,
            tipo: i.type, 
            oldTag: i.tag,
            newTag: newTag,
            isRef: false,
            position: -1,
          });
          i.tag = newTag;
          const container = tagsNews.find(t => t.tipo == FieldType.SECTION && t.oldId == i.parentItemId);
          if(container){
            i.parentItemId = container.id;
          }
          let fContent = i.content;
          const tagsForm = Sh.extractTagsPositions(i.content);
          const sortedTagsForm = [...tagsForm].sort((a, b) => b.init - a.init);
          for(const t of sortedTagsForm){
            const hasValue = t.content.toUpperCase().indexOf("VALUE");
            const told = t.content.replace(".value", "").replace(".VALUE", "");

            const oldTag = tagsNews.find(tn => tn.oldTag.toUpperCase() === told.toUpperCase() && !tn.isRef);
            if(oldTag!=null){
              fContent = Sh.replaceByPosition(fContent, t.init, t.length, "{"+ oldTag.newTag + (hasValue!== -1 ? ".value}" : "}"));
            }
            
          }
          i.content = fContent;

        }



        //Actualizamos las referencias de grilla
        for(const i of tagsNews.filter(t => t.isRef)){
          const hasValue = i.oldTag.toUpperCase().includes(".VALUE");
          const oldTag = i.oldTag.replace(".value", "").replace(".VALUE", "");
          const ref =  tagsNews.filter(t => !t.isRef).find(t => t.oldTag.toUpperCase() === oldTag.toUpperCase());
          let newTag = i.oldTag;
          if(ref){
            newTag  = ref.newTag + (hasValue ? ".value" : "");
          }
          const grid = items.find(gi => gi.id === i.id);
          if(grid){
            grid.gridDesign.rows[i.position].cells[i.column].tag = newTag;
          }
        }
        // Actualizamos los Gráficos, que todos son referencias
        for(const i of itemsChars){
          let newTag = i.tag;
          i.isNew = true;
          if(this.findTag(i.tag) || tagsNews.find(t => t.newTag == i.tag && t.id != i.id)!= null){
            newTag = this.getNewTag(tagsNews.map(t => t.newTag))
          }
          i.id = uuidv4();
          
          tagsNews.push({
            id: i.id,
            tipo: i.type, 
            oldTag: i.tag,
            newTag: newTag,
            isRef: false,
            position: -1,
          });
          i.tag = newTag;
          const container = tagsNews.find(t => t.tipo == FieldType.SECTION && t.oldId == i.parentItemId);
          if(container){
            i.parentItemId = container.id;
          }
          for(const it of i.items){
            const tfound = tagsNews.find(t => t.oldTag == it.tag && !t.isRef);
            if(tfound){
              it.tag = tfound.newTag;
            }
          }
        }

      this.currentDesign.value.items = [...this.currentDesign.value.items, ...items];

     // this.setDesign(form);
    } catch (e) {
      this.errors.value = ["Error"];
    } finally {
      this.loading.value = false;
    }
  }
  asignItemNew = async (itemId: string, item: FormDesignItemDto) => {
    try{
      const itemNew = await Sh.api<FormDesignItemDto>({
        method: 'GET',
        route: apiRoutes.surveyDesingItem,
        params: [itemId]
      });
      itemNew.id = item.id;
      itemNew.inheritItemId = itemId;
      itemNew.formId = item.formId;
      itemNew.isNew = true;
      itemNew.tag = this.getNewTag();
      if(itemNew.type === FieldType.EXCELGRID){
        for(const row of itemNew.gridDesign.rows){
          for(const c of row.cells){
            c.tag = this.getNewTag();
            c.isReference = false;
          }
        }
      }
      this.asignItem(item, itemNew);
    }catch(e){
      console.log("error asignando item", e);
      return [];
    }
  }
  canRemoveDesign = async (id: string): Promise<boolean> => {
    try{
      this.isLoading.value = true;
      const result = await Sh.api<boolean>({
        method: "GET", 
        route: apiRoutes.surveyCanDelete, 
        params: [id]
      });
      return result;
    }catch(e){
      return false;
    }finally{
      this.isLoading.value = false;
    }
  }
  removeDesign = async (id: string): Promise<boolean> => {
    try{
      this.isLoading.value = true;
      const result = await Sh.api<boolean>({
        method: "DELETE", 
        route: apiRoutes.surveyDelete, 
        params: [id]
      });
      
      return result;
    }catch(e){
      return false;
    }finally{
      this.isLoading.value = false;
    }
  }



  //#region Response
    getResponseItemValue = (item: FormDesignItemDto ) => {
      const curResponse = this.currentResponse.value;
      if(!curResponse || !curResponse.items || !curResponse.items.length) return this.defaltItemValue(item);
      const curResponseItem = curResponse.items.find(i => i.formsDesignItemId === item.id);
      if(!curResponseItem){
        const {currentContext} =  GlobalState();
        const value = this.defaltItemValue(item);
        this.addResponseItem(item, this.defaltItemValue(item), currentContext.user.id)
        return value;
      }
      return curResponseItem.value;
    }
    getResponse = async (formDesignId: string, entityId: string) => {
      try {
        this.loading.value = true;
        const {currentContext} =  GlobalState();
        const result = await Sh.api<SurveyResponseCompleteDto>({
          method: 'GET',
          route: apiRoutes.surveyGetResponse,
          params: [entityId, formDesignId]
        });
        this.setDesign(result.design);
        this.setResponse(result.response?? null, entityId, currentContext.user.id);
        const formRefs = this.currentDesign.value.items.filter(i => !Sh.isNullOrEmptyOrZero(i.inheritItemId) &&  i.type!== FieldType.APIREST); 
        const apis = this.currentDesign.value.items.filter(i => i.type== FieldType.APIREST);
        if(formRefs.length){
          const resultIn = await Sh.api<SurveyResponseCompleteDto>({
            method: 'POST',
            route: apiRoutes.surveyInherits,
            data: formRefs.map(f => f.inheritItemId),
            params: [entityId]
          });
          if(Object.keys(resultIn).length !=0){
            const designInherits = this.currentDesign.value.items.filter(i => i.type!== FieldType.APIREST && !Sh.isNullOrEmptyOrZero(i.inheritItemId));
            for(const i of designInherits){
              if(resultIn[i.inheritItemId]){
                i.response.value = resultIn[i.inheritItemId];
                this.formatValue(i.response, i );
              }
            }
          }
          
        }
        if(apis.length){
          const {
            currentContext
          } = storeToRefs(GlobalState());
          for(const a of apis){
            if(Sh.isNullOrEmptyOrZero(a.content)) continue;
            const apiParams: SurveyApiParms = JSON.parse(a.content);
            for(const v of apiParams.globals){
              switch(v.var){
                case "id-finhava":
                  v.value = currentContext.value.entity.finhavaId;
                  break;
                case "cif-entidad":
                  v.value = currentContext.value.entity.identity.vatNumber;
                  break;
              }
            }
            try{
                const res = await  this.getDataApi(apiParams);
                const response =  this.currentResponse.value.items.find(i => i.formsDesignItemId == a.id);
                if(response){
                  response.value = res.value ;
                  this.formatValue(response, a );
                }
                
            }catch(e){
              console.log("error finhava", e)
            }
             // const value = this.getDataApi()
          }
        }
        this.calculateFormulas();
      } catch (error) {
        throw error;
      }finally{
        this.loading.value = false;
      }
    }
/*     tagsWithValues = computed(() => {
      const tags: {tag: string, weight: number,  value: number}[] = [];
      
      return tags.map(i => i.tag);
    })
 */
    tagsValues = computed(() => {
      let tags: {[key: string]:{value: number, weight: number}} = {};
      const istems = this.formulaAssignable.value;
      for(const i of istems){
        switch(i.type){
          case FieldType.TEXT:
          case FieldType.DATE:
            tags[i.tag] = {value: null, weight:  i.weight  };
            break;
          case FieldType.DATERANGE:
            tags[i.tag] = {value: null, weight:  i.weight  };
            if(i.value && i.value.init && i.value.end){
              tags[i.tag].value = (new Date(i.value.end).getTime() - new Date(i.value.init).getTime()) / 1000 / 86400;
            }
            break;
          case FieldType.DROPDOWN:
            tags[i.tag] = {value: null, weight:  i.weight  };

          case FieldType.MULTYDROPDOWN:
          case FieldType.GRID:
          case FieldType.EXCELGRID:
        }
      }

      return tags;
    })
    calculateFormulasNew = async () => {
      const formulas = this.currentDesign.value.items.filter(i=> i.type == FieldType.FORMULE);
      const formulasToAply: {id: string, tag: string, content: string,  tags: TagObject[]}[] = [];
      for(const i of formulas){
        if(Sh.isNullOrEmptyOrZero(i.content)) continue;
        const tag: {id: string, tag: string, content: string, tags: TagObject[]} = {id: i.id, tag: i.tag, content: i.content, tags: Sh.extractTags(i.content)};
        formulasToAply.push(tag);
      }
      const topo: TagCalculateItem[] = Sh.topologicalSortFormulas(formulasToAply.map(i=> <TagCalculateItem>{tag: i.tag, tags: i.tags}));
      for(const i of formulas){
        const formula = i.content;
      }
    }
    
      
       ordenArray = (
        arrayAOrdenar: {id: string, tag: string, content: string,  tags: TagObject[]}[] ,
        arrayDeOrden: TagCalculateItem[]
      ): {id: string, tag: string, content: string,  tags: TagObject[]}[]   => {
        const ordenTags = arrayDeOrden.map(item => item.tag);
      
        arrayAOrdenar.sort((a, b) => {
          const indexA = ordenTags.indexOf(a.tag);
          const indexB = ordenTags.indexOf(b.tag);
      
          // Si un tag no se encuentra en el array de orden, lo dejamos al final (o al principio, según preferencia)
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
      
          return indexA - indexB;
        });
      
        return arrayAOrdenar;
      }
    calculateFormulas = async () => {
      try {
        const formulas = this.currentDesign.value.items.filter(i=> i.type == FieldType.FORMULE);
        const tagsValues = this.getTagsWithValues();
        if(!formulas || formulas.length == 0 ) {
          this.refreshGridRef(tagsValues);
          this.refreshCharts(tagsValues);
          return;
        }
        const frm = this.formulaAssignable.value;
        let formulasToAply: {id: string, tag: string, content: string,  tags: TagObject[]}[] = [];
        for(const i of formulas){
          if(Sh.isNullOrEmptyOrZero(i.content)) continue;
          const tag: {id: string, tag: string, content: string, tags: TagObject[]} = {id: i.id, tag: i.tag, content: i.content, tags: Sh.extractTags(i.content)};
          formulasToAply.push(tag);
        }
        if(!formulasToAply.length){
          this.refreshGridRef(tagsValues);
          this.refreshCharts(tagsValues);
          return;
        }
        const topo: TagCalculateItem[] = Sh.topologicalSortFormulas(formulasToAply.map(i=> <TagCalculateItem>{tag: i.tag, tags: i.tags}));
        formulasToAply = this.ordenArray(formulasToAply, topo);
        
        for(const f of  formulasToAply){
          let formula: string = f.content;
          try{

            for(const t of f.tags){
              try{


                formula = formula.replace( `{${t.tag}.value}`,tagsValues[t.tag].value.toString() );
                formula = formula.replace( `{${t.tag}}`,tagsValues[t.tag].weight.toString() );
                }catch(e){
                  console.log(e);
                }
              }
              const curItem = this.currentDesign.value.items.find(i => i.id == f.id);
              let result = Sh.evaluateForm(formula);
              if (typeof result === "number" && (!isFinite(result) || isNaN(result))) {
                result = 0;
    
              }
              tagsValues[f.tag].value =  result;
              tagsValues[f.tag].weight =  result;
              if(typeof result == 'number' || typeof result == 'bigint'){
                this.changeReponseValue(curItem, result);
                
              }else{
                this.changeReponseValue(curItem, 0);
              }
          }catch(e){
            console.log(e)
          }
          
        }  


        this.refreshCharts(tagsValues);
        this.refreshGridRef(tagsValues);
      } catch (error) {
        console.log(error);
      }
      

    }
    refreshGridRef = (tagsValues: {[key: string]: TagValueWeighObject}) => {
      const grids = this.currentDesign.value.items.filter(i => i.type == FieldType.EXCELGRID && Sh.isNullOrEmptyOrZero(i.inheritItemId));
      for(const [indexGrids, g] of grids.entries()){
        if(g.id == "1d146b73-7e9d-4cdc-9f0f-0451027fb3aa"){
          console.log("stop");
        }
          for(const [indexRows, i] of g.gridDesign.rows.entries()){
            for(const [indexCells, j] of i.cells.entries()){
            try{
              if(j.isReference){
                const tag = j.tag.split(".")[0];
                const includeValue = j.tag.includes(".");
                const curTagValue = tagsValues[tag];
                if(curTagValue == undefined) continue;

                const response = this.currentResponse.value.items.find(it => it.formsDesignItemId == g.id);
                let value = 0;
                
                if(includeValue){
                  value = curTagValue.value ?? 0;
                }else if(curTagValue.hasValue!==undefined){
                  if(!curTagValue.hasValue){
                    value = curTagValue.weight;
                  }else{
                    value = curTagValue.value;
                  }
                }else{
                  value = curTagValue.weight;
                }

                value = typeof value === 'number' && !isNaN(value) ? value : 0;
/*               if(j.tag.includes(".")){
                value = tagsValues[tag].hasValue ?  tagsValues[tag].value : tagsValues[tag].weight;
              }else{
                  value = tagsValues[tag].weight;
              } */
                response.value[indexRows][indexCells] = value;
                this.changeReponseValue(g, response.value);

              }
                }catch(e){
                    console.log("Error", e);
                }
              }

          }
        
        
      }
    }
    refreshCharts = (tagsValues: {[key: string]: TagValueWeighObject}) => {
      if(!this.currentResponse || this.currentResponse.value.items.length == 0) return;
      const charts = this.currentDesign.value.items.filter(i => i.type == FieldType.CHART);
      if(!charts || charts.length == 0) return;
      for(const c of charts){
        const response = this.currentResponse.value.items.find(i => i.formsDesignItemId == c.id);
        if(!response) continue;
        response.value = [];
        for(const i of c.items){
          const tag = i.tag;
          //response.value.push(tagsValues[tag] ? tagsValues[tag].value : 0);
          const val = tagsValues[tag]?.value;
          response.value.push(typeof val === 'number' && !isNaN(val) ? val : 0);
          continue;
          if(!this.tagsWithValues.value[tag] ){
            response.value.push(0);
          }else{
            response.value.push(this.tagsWithValues.value[tag].value);
          }
        }
        this.changeReponseValue(c, response.value);
      }
    }

    getValueOfItemGrid = (item: FormDesignItemDto, tag: string): number => {
      if(!item.response) return 0;
      

    }
    getValueOfItemDrawer = (item: FormDesignItemDto, tag: string, isValue: boolean = true): number => {
      if(!item.response) return 0;
      const dr = item.items.find(i => i.tag === tag);
      switch(item.itemsType){
        case ItemsType.DATE:
        case ItemsType.TEXT:
          try{
            if(dr) return  parseFloat(dr.value);
            return 0;
          }catch(e){
            return 0;
          }
        case ItemsType.NUMBER:                  
          if(!isValue) return parseFloat(dr.value);
         const idx = item.items.findIndex(i => i.tag == tag);
         if(idx == -1) return 0;
         if(!item.response.value[idx]) return 0;
         return parseFloat(item.response.value[idx]); 
      }
    }
    getValueOfDesignItem = (item: FormDesignItemDto, isValue: boolean = true): number => {
      if(!item.response) return 0;
      if(!item.response.value) return 0;
      const value: any = item.response.value;

      switch(item.type){
        case FieldType.TEXT:
        case FieldType.DATE:
          if(Sh.isNullOrEmptyOrZero(value)) return item.weightEmpty ?? 0;
          return item.weight ?? 0;
        case FieldType.NUMBER:
          if(isValue)
            return value;
          return Sh.isNullOrEmptyOrZero(value) ? item.weightEmpty ?? 0 : item.weight ?? 0;
        case FieldType.DATERANGE:
          
          const init = value.init ? new Date(Sh.toShortDate(value.init, true)).getTime() : 0;
          const end = value.end ? new Date(Sh.toShortDate(value.end, true)).getTime() : 0;
          if(!init || !end) return item.weightEmpty ?? 0;
          if(!isValue) return item.weight ?? 0;
          return ((end - init) / 1000) / 86400;
        case FieldType.DROPDOWN:
        case FieldType.MULTYDROPDOWN:
          
          const val = value.reduce((acc, index) => acc +  parseFloat(item.items[index].value), 0);
          if(!val && item.weightEmpty) return item.weightEmpty;

          if(!isValue)
              return  Sh.isNullOrEmptyOrZero(val) ? item.weightEmpty ?? 0 : item.weight ?? 0;
          return val;
        case FieldType.GRID:
          if(item.itemsType == ItemsType.NUMBER){
            const val = value.reduce((acc, obj) => acc + (obj ? parseFloat(obj): 0) , 0);
            if(!val && item.weightEmpty) return item.weightEmpty;
            if(!val) return 0;
            if(!isValue)
              return  Sh.isNullOrEmptyOrZero(val) ? item.weightEmpty ?? 0 : item.weight ?? 0;
            return val;
          }else{
            const val = value.reduce((acc, obj, idx) => acc +  parseFloat(item.items[idx].value), 0);
            if(!val && item.weightEmpty) return item.weightEmpty;
            if(!val) return 0;
            if(!isValue)
              return  Sh.isNullOrEmptyOrZero(val) ? item.weightEmpty ?? 0 : item.weight ?? 0;
            return val;
          }
        case FieldType.FILE:
          return  Sh.isNullOrEmptyOrZero(value.id) ? item.weightEmpty ?? 0 : item.weight ?? 0;
        case FieldType.FORMULE:
        case FieldType.FORMREF:
        case FieldType.APIREST:
              return  !Sh.isNullOrEmptyOrZero(value) ? parseFloat(value) : 0;
      }
      return Sh.isNullOrEmptyOrZero(value) ?  item.weightEmpty ?? 0 : item.weight ?? 0;
    }
    saveResponse = async () =>  {
      try{
        this.asignDesignItemsToResponse();
        SharedService.loadingMsg.value = "Guardando formulario...";
        this.loading.value = true;

        const st = this.responseStatus.value;
        this.currentResponse.value.questionsRequireds = st.requireds;
        this.currentResponse.value.questionsEnded = st.response;
        this.currentResponse.value.result = st.result;

        // Todo resultado del formulario.
        const result = await Sh.api<SurveyResponseDto>({
          method: 'POST',
          route: apiRoutes.surveySaveResponse,
          data: SurveyResponseDto.toSend(this.currentResponse.value)
        });
        this.setResponse(result);
        this.loading.value = false;
        SharedService.loadingMsg.value = "";
        //this.calculateFormulas();
      }catch(e){
        throw e;
      }
    }
    asignDesignItemsToResponse = () => {
      for(const i of this.currentResponse.value.items){
        const rDesign = this.currentDesign.value.items.find(id => id.id === i.formsDesignItemId );
        if(rDesign){
          i.value = rDesign.response.value;
        }
      }
    }

    onChangeResponseItem = () => {
      this.calculateFormulas();
    }
    changeState = async (newState: Form_status) => {
      this.loading.value = true;
      const result = await Sh.api<boolean>({
        method: 'POST',
        route: apiRoutes.surveyChangeStatus,
        params: [this.currentResponse.value.id, newState]
      });
      if(result == true){
        this.changeStatus(newState);
        
      }
    }


  //#endregion Response
  //#region Api
    getListApi = async  (): Promise<boolean | SurveyApiListItemDto[]> => {
        
      try {
        this.loading.value = true;
        const result = await Sh.api<SurveyApiListItemDto[]>({
          method: 'GET',
          route: apiRoutes.surveyApiList,
        });
        this.loading.value = false;
        return result;  
      } catch (error) {
        this.loading.value = false;
        return false;
      }
    }
    getApi = async  (apiId: string): Promise<boolean | SurveyApiDto> => {
        
      try {
        this.loading.value = true;
        const result = await Sh.api<SurveyApiDto>({
          method: 'GET',
          route: apiRoutes.surveyApiGet,
          params: [apiId]
        });
        this.loading.value = false;
        return result;  
      } catch (error) {
        this.loading.value = false;
        return false;
      }
    }
    updateApi = async (api: SurveyApiDto): Promise<boolean | SurveyApiDto>  => {
      try {
        this.loading.value = true;
        const result = await Sh.api<SurveyApiDto>({
          method: 'POST',
          route: apiRoutes.surveyApiSave,
          data: api,
        });
        this.loading.value = false;
        return result;  
      } catch (error) {
        this.loading.value = false;
        return false;
      }
    }
    getVarsApi = (api: SurveyApiDto): SurveyApiParms => {
      const globalsVars:{var: string, description: string, value: string}[] = [];
      if(api.url.includes("{id-finhava}")) globalsVars.push({var: "id-finhava", description: "id de finhava", value : ""});
      if(api.url.includes("{cif-entidad}")) globalsVars.push({var: "cif-entidad", description: "cif de la entidad", value: ""});
      const head = Sh.getObjectFromStringKeyValue(api.headers);
      const customVars = Sh.getObjectFromStringKeyValue(api.customVars);
      const custom: {var: string, description: string, value: string }[] = [];
      for(const i of Object.keys(customVars)){
        if(api.url.includes("["+i+"]")){
          custom.push({var: i, description: customVars[i], value: "" })
        }
      }
      return {
        url: api.url,
        method: api.method,
        property: api.property,
        globals: globalsVars,
        custom: custom, 
        header: Object.keys(head).map(k => ({var: k, value: head[k] }))
      }
    }
    getDataApi = async (surveyApiparams: SurveyApiParms, api?: SurveyApiDto ): Promise<ResultTest>  => {
      const options: ApiInterface = {
        method: api ? api.method :  surveyApiparams.method ,
        route:  api ? api.url : surveyApiparams.url, 
        external: true, 
        auth: false,
      };
      if(Object.keys(surveyApiparams.header).length!=0){
        const head: {}= {};
        for(const h of surveyApiparams.header){
          head[h.var] = h.value;
        }
        options.headers = head;
      }
      if(surveyApiparams.globals.length){
        for(const g of surveyApiparams.globals){
          options.route = options.route.replace(`{${g.var}}`, g.value);
        }
      }
      if(surveyApiparams.custom.length){
        for(const g of surveyApiparams.custom){
          options.route = options.route.replace(`[${g.var}]`, g.value);
        }
      }
      const result:any = await Sh.api(options);
      const res = JSONPath({path:`$.${api ? api.property : surveyApiparams.property}`, json: result });
      return {
        returnText: JSON.stringify(result, null, "  "),
        value: res && res.length!=0 ? res[0] : 0, 
        url: options.route
      }
    }
    async print(type: 'preview'|'response', id: string, urlDownload: Ref<string>, nameFileDownload: Ref<string>, msgProgress: Ref<string>,  entityId?: string){
      var connection = new signalR.HubConnectionBuilder()
        .withUrl(Sh.basicUrl + "/printhub", {withCredentials: false})
        .build();
      let action = "PrintDesign";
      if(type === 'response'){
        action = "PrintResponse";
      }
       
      connection.on("PrintComplete", (msg: any) => {
        // msg.file puede ser base64 (string) o array de bytes
        function base64ToUint8Array(base64) {
          const binary = atob(base64);
          const len = binary.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
          }
          return bytes;
        }

        let byteArray;
        if (typeof msg.file === 'string') {
          byteArray = base64ToUint8Array(msg.file);
        } else if (Array.isArray(msg.file)) {
          byteArray = new Uint8Array(msg.file);
        } else {
          byteArray = new Uint8Array(msg.file);
        }

        const blob = new Blob([byteArray], { type: "application/pdf" });
        urlDownload.value = URL.createObjectURL(blob);
        nameFileDownload.value = msg.fileName || 'documento.pdf';
        msgProgress.value = "";

        //connection.stop();
      });
      connection.on("PrintProgress", (msg: any) => {
        msgProgress.value = msg.message;
        console.log(msg);
      });
      connection.on("PrintError", (msg: any) => {
        alert(msg);
          connection.stop();
      });
      await connection.start();
      connection.invoke(action, id, entityId).then(() =>{
        connection.stop();
      }
         )
    .catch(console.error);;
    }

  //#endregion api
  



}

// Exporta la instancia de la clase

let _suveryInstance:SurveyStore = null;
//const suveryInstance = useSurvey();
const surveyInstance = (): SurveyStore => {
  if(!_suveryInstance){
    _suveryInstance = new SurveyStore();
    //_suveryInstance.init();
  }
  return _suveryInstance;
};
export default surveyInstance;
